import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { tabbable as j } from "tabbable";
import { addChangeListener as ve, getUser as be, setPreferredStore as z, getPreferredStore as V } from "@rei/session";
import { CdrText as C, IconCheckSm as te, IconHeartFill as ke, CdrButton as A, CdrInput as Ce, CdrLink as D, IconMyLocation as Ie, IconSearch as we, IconXSm as oe, IconErrorFill as Ne, IconCaretLeft as xe, IconXLg as se, IconMinusFill as Le, IconBikeShop as Pe, IconCaretDown as De, IconExternalLink as Ae, IconHeartStroke as Fe, IconSnow as Me, IconTent as He, IconRefresh as Be, IconShipping as Ee, IconVirtualOutfitting as Te, IconLocationPinFill as $e } from "@rei/cedar";
import { openBlock as d, createElementBlock as S, createStaticVNode as ae, resolveComponent as i, createVNode as r, withCtx as c, createTextVNode as h, toDisplayString as y, createElementVNode as u, normalizeClass as H, Fragment as P, createCommentVNode as p, pushScopeId as $, popScopeId as R, createBlock as g, withDirectives as B, vShow as E, renderList as re, onMounted as Re, unref as x, withKeys as G, withModifiers as W } from "vue";
import N from "dayjs";
import ie from "dayjs/plugin/customParseFormat";
import ne from "dayjs/plugin/utc";
import le from "dayjs/plugin/timezone";
import Oe from "js-cookie";
const k = (e, o) => {
  const t = e.__vccOpts || e;
  for (const [l, s] of o)
    t[l] = s;
  return t;
}, ze = {
  name: "LineDivider"
}, Ve = {
  class: "line-divider",
  "data-ui": "line-divider"
};
function Ue(e, o, t, l, s, a) {
  return d(), S("div", Ve);
}
const F = /* @__PURE__ */ k(ze, [["render", Ue], ["__scopeId", "data-v-019b4c43"]]);
const qe = {
  name: "LoadingPlaceholder"
}, Xe = {
  class: "loading-placeholder",
  "data-ui": "loading-placeholder"
}, Ye = /* @__PURE__ */ ae('<div class="loading-placeholder__big" data-v-e379b9fb><div class="my-store-loading-transition" data-v-e379b9fb></div><div class="my-store-loading-transition" data-v-e379b9fb></div></div><div class="loading-placeholder__small my-store-loading-transition" data-v-e379b9fb></div><div class="loading-placeholder__small my-store-loading-transition" data-v-e379b9fb></div>', 3), je = [Ye];
function Ge(e, o, t, l, s, a) {
  return d(), S("div", Xe, je);
}
const We = /* @__PURE__ */ k(qe, [["render", Ge], ["__scopeId", "data-v-e379b9fb"]]);
const Ze = {
  name: "LoadingStores",
  components: {
    CdrText: C,
    LineDivider: F,
    LoadingPlaceholder: We
  },
  props: {
    loadingText: {
      type: String,
      default: "Searching..."
    }
  }
}, Ke = {
  class: "loading-stores",
  "data-ui": "loading-stores"
}, Je = {
  class: "loading-stores__placeholders",
  "data-ui": "loading-stores-placeholders"
};
function Qe(e, o, t, l, s, a) {
  const n = i("cdr-text"), m = i("line-divider"), _ = i("loading-placeholder");
  return d(), S("div", Ke, [r(n, {
    class: "loading-stores__text",
    "data-ui": "loading-stores-text"
  }, {
    default: c(() => [h(y(t.loadingText), 1)]),
    _: 1
  }), r(m), u("div", Je, [r(_), r(_)])]);
}
const et = /* @__PURE__ */ k(Ze, [["render", Qe], ["__scopeId", "data-v-d9f3a2f8"]]);
const tt = {
  name: "MyRei",
  components: {
    CdrText: C,
    IconCheckSm: te,
    IconHeartFill: ke
  },
  props: {
    indicatorOnly: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    indicatorClasses() {
      return ["my-rei__indicator", "my-rei--center", {
        "my-rei__indicator--loading": this.loading,
        "my-store-loading-transition": this.loading
      }];
    }
  }
}, de = (e) => ($("data-v-85060a0d"), e = e(), R(), e), ot = {
  class: "my-rei my-rei--center",
  "data-ui": "my-rei-component"
}, st = /* @__PURE__ */ de(() => /* @__PURE__ */ u("span", {
  class: "my-rei-title"
}, "My REI", -1)), at = /* @__PURE__ */ de(() => /* @__PURE__ */ u("div", {
  class: "my-rei__line",
  "data-ui": "my-rei-line"
}, null, -1)), rt = {
  class: "my-rei__check-icon",
  "data-ui": "my-rei-check"
};
function it(e, o, t, l, s, a) {
  const n = i("IconHeartFill"), m = i("cdr-text"), _ = i("IconCheckSm");
  return d(), S("div", ot, [r(m, {
    tag: "span",
    class: H(a.indicatorClasses),
    "data-ui": "my-rei-text"
  }, {
    default: c(() => [u("span", null, [r(n, {
      size: "small"
    })]), st]),
    _: 1
  }, 8, ["class"]), t.indicatorOnly ? p("", !0) : (d(), S(P, {
    key: 0
  }, [at, u("div", rt, [r(_)])], 64))]);
}
const q = /* @__PURE__ */ k(tt, [["render", it], ["__scopeId", "data-v-85060a0d"]]);
const nt = {
  name: "LoadingFlyout",
  components: {
    LineDivider: F,
    MyRei: q
  }
}, ce = (e) => ($("data-v-5fa68883"), e = e(), R(), e), lt = {
  class: "loading-flyout"
}, dt = /* @__PURE__ */ ce(() => /* @__PURE__ */ u("div", {
  class: "my-store--sr-only"
}, "Loading preferred store", -1)), ct = {
  class: "loading-flyout__placeholders"
}, ut = /* @__PURE__ */ ae('<div class="loading-flyout__name" data-v-5fa68883><div class="my-store-loading-transition" data-v-5fa68883></div><div class="my-store-loading-transition" data-v-5fa68883></div></div><div class="loading-flyout__phone my-store-loading-transition" data-v-5fa68883></div><div class="loading-flyout__address my-store-loading-transition" data-v-5fa68883></div><div class="loading-flyout__address my-store-loading-transition" data-v-5fa68883></div><div class="loading-flyout__page-btn my-store-loading-transition" data-v-5fa68883></div>', 5), mt = /* @__PURE__ */ ce(() => /* @__PURE__ */ u("div", {
  class: "loading-flyout__all-stores-btn my-store-loading-transition"
}, null, -1));
function ht(e, o, t, l, s, a) {
  const n = i("my-rei"), m = i("line-divider");
  return d(), S("div", lt, [r(n, {
    "indicator-only": !0,
    loading: !0
  }), dt, u("div", ct, [ut, r(m), mt])]);
}
const _t = /* @__PURE__ */ k(nt, [["render", ht], ["__scopeId", "data-v-5fa68883"]]), M = {
  methods: {
    // Sends analytics click tracking event
    sendClickAnalytics(e) {
      !window || !window.metrics || window.metrics.link(e);
    }
  }
};
const ft = {
  name: "MyLocationInput",
  components: {
    CdrButton: A,
    CdrInput: Ce,
    CdrLink: D,
    IconMyLocation: Ie,
    IconSearch: we,
    IconXSm: oe,
    IconErrorFill: Ne,
    LineDivider: F
  },
  mixins: [M],
  props: {
    analyticsPageName: {
      type: String
    },
    initialSearchValue: {
      type: String,
      default: ""
    },
    initialErrorText: {
      type: String,
      default: ""
    },
    displayAllStoresBtn: {
      type: Boolean,
      default: !0
    },
    userCoords: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      locationInput: {
        value: "",
        error: null
      },
      locationIsDenied: !1,
      displayXBtn: !1
    };
  },
  computed: {
    helpText() {
      return this.locationInput.error || "Example: 98102 or Taos, NM";
    },
    inputTextHelperClasses() {
      return {
        "my-location-input__help-text--error": this.inputHasError,
        "my-location-input__help-text": !0
      };
    },
    inputClasses() {
      return {
        "my-location-input__search-box": !0,
        "my-location-input--invalid": !!this.locationInput.error
      };
    },
    inputHasError() {
      return this.locationIsDenied || !!this.locationInput.error;
    }
  },
  watch: {
    "locationInput.error": function(e) {
      e && (this.$refs.locationInput.$el.focus(), this.sendClickAnalytics({
        linkName: `rei:my store widget_search error_${e}`,
        pageName: this.analyticsPageName
      }));
    }
  },
  /*
    When component is mounted checks the following
    - If user blocked location in the past, hide my location link. Note: This works only on Chrome and Edge
    - If there is an initialSearchValue value, means the user is editing a location
  */
  mounted() {
    this.locationInput.value = this.initialSearchValue, this.locationInput.error = this.initialErrorText, this.displayXBtn = !!this.initialSearchValue;
  },
  methods: {
    /*
      Dispatch browser api to get user location
    */
    handleMyLocation() {
      !this.userCoords && "geolocation" in navigator ? navigator.geolocation.getCurrentPosition(this.handleAllowLocation, this.handleBlockLocation) : this.$emit("search-stores", this.userCoords), this.sendClickAnalytics({
        linkName: "rei:my store widget_use my location",
        pageName: this.analyticsPageName
      });
    },
    /*
      Emit event to search stores by latitude and longitude retrieved from browser api
    */
    handleAllowLocation({
      coords: e
    }) {
      this.$emit("search-stores", {
        latitude: parseFloat(e.latitude.toFixed(3)),
        longitude: parseFloat(e.longitude.toFixed(3)),
        updateUserLocation: !0
      });
    },
    /*
      Set corresponding status if user blocks location
    */
    handleBlockLocation() {
      this.locationIsDenied = !0, this.locationInput.error = "Please enable location access or use search box";
    },
    /*
      Search stores based on user input text
    */
    handleSearch(e) {
      e.preventDefault(), this.locationInput.error = this.validateInput(), this.locationIsDenied = !1, this.displayXBtn = !!this.locationInput.error, this.locationInput.error || this.$emit("search-stores", {
        searchTerm: this.locationInput.value
      }), this.sendClickAnalytics({
        linkName: "rei:my store widget_searchbutton",
        pageName: this.analyticsPageName
      });
    },
    /*
      Validate user input text
      - If the string is only numbers, it should be exactly five digits or nine digits and an optional dash is
        allowed between the 5th and 6th digits.
      - Otherwise, it just should just require at least two characters.
    */
    validateInput() {
      const {
        value: e
      } = this.locationInput, o = /[a-zA-Z]/g, t = /[~@#$&*()+={}[\]|?:^<>'"/;`%]/, l = /(^\d{5}$)|(^\d{5}-\d{4}$)/, s = o.test(e), a = t.test(e);
      return s && e.length < 2 || a || !e ? "Use format: Denver, CO" : !s && !l.test(e) ? "Please enter 5 digit ZIP" : null;
    },
    /*
      Reset input state based on action
      - If clicked on X button, clear value and error
      - If @input event is fired, clear only error and keep previous value
    */
    resetInput(e, o = !0) {
      this.displayXBtn = !1, this.locationIsDenied = !1, o && (this.locationInput.value = ""), this.locationInput.error = null;
    },
    trackAllStoresClick() {
      this.sendClickAnalytics({
        linkName: "rei:my store widget_visit directory of all stores",
        pageName: this.analyticsPageName
      });
    }
  }
}, yt = {
  class: "my-location-input",
  "data-ui": "my-location-input"
}, pt = ["role"];
function gt(e, o, t, l, s, a) {
  const n = i("IconMyLocation"), m = i("cdr-link"), _ = i("IconErrorFill"), v = i("IconXSm"), b = i("cdr-button"), I = i("IconSearch"), w = i("cdr-input"), L = i("line-divider");
  return d(), S("div", yt, [u("form", {
    "data-ui": "search-form",
    onSubmit: o[2] || (o[2] = (...f) => a.handleSearch && a.handleSearch(...f))
  }, [r(w, {
    ref: "locationInput",
    modelValue: s.locationInput.value,
    "onUpdate:modelValue": o[0] || (o[0] = (f) => s.locationInput.value = f),
    label: "ZIP or City, State",
    "data-ui": "search-input",
    class: H(a.inputClasses),
    "aria-invalid": a.inputHasError ? "true" : "false",
    autocomplete: "off",
    onInput: o[1] || (o[1] = (f) => a.resetInput(f, !1))
  }, {
    info: c(() => [r(m, {
      tag: "button",
      modifier: "standalone",
      type: "button",
      class: "my-location-input__link",
      "data-ui": "my-location-link",
      onClick: a.handleMyLocation
    }, {
      default: c(() => [r(n, {
        "inherit-color": ""
      }), h(" Use my location ")]),
      _: 1
    }, 8, ["onClick"])]),
    "helper-text-bottom": c(() => [u("span", {
      "aria-live": "off",
      class: H(a.inputTextHelperClasses),
      "data-ui": "search-help-text",
      role: a.inputHasError ? "alert" : null
    }, [a.inputHasError ? (d(), g(_, {
      key: 0,
      size: "small",
      "inherit-color": ""
    })) : p("", !0), h(" " + y(a.helpText), 1)], 10, pt)]),
    "post-icon": c(() => [B(r(b, {
      "icon-only": !0,
      "aria-label": "Clear input",
      class: "my-location-input__btn",
      type: "button",
      "data-ui": "clear-search-button",
      onClick: a.resetInput
    }, {
      icon: c(() => [r(v, {
        "inherit-color": ""
      })]),
      _: 1
    }, 8, ["onClick"]), [[E, s.displayXBtn]]), B(r(b, {
      "icon-only": !0,
      "aria-label": "Search stores",
      class: "my-location-input__btn my-location-input--icon",
      type: "button",
      "data-ui": "search-button",
      onClick: a.handleSearch
    }, {
      icon: c(() => [r(I, {
        "inherit-color": ""
      })]),
      _: 1
    }, 8, ["onClick"]), [[E, !s.displayXBtn]])]),
    _: 1
  }, 8, ["modelValue", "class", "aria-invalid"])], 32), t.displayAllStoresBtn ? (d(), S(P, {
    key: 0
  }, [r(L), t.displayAllStoresBtn ? (d(), g(b, {
    key: 0,
    tag: "a",
    modifier: "secondary",
    href: "/stores/map",
    class: "my-location-input__stores-btn",
    "full-width": !0,
    "data-ui": "all-stores-button",
    onClick: a.trackAllStoresClick
  }, {
    default: c(() => [h(" Visit directory of all stores ")]),
    _: 1
  }, 8, ["onClick"])) : p("", !0)], 64)) : p("", !0)]);
}
const St = /* @__PURE__ */ k(ft, [["render", gt]]);
const vt = {
  name: "MyStoreHeader",
  components: {
    CdrButton: A,
    CdrText: C,
    IconCaretLeft: xe,
    IconXLg: se
  },
  props: {
    displayBackArrow: {
      type: Boolean,
      default: !1
    },
    title: {
      type: String,
      required: !0
    }
  }
}, bt = {
  class: "my-store-header",
  "data-ui": "my-store-header"
};
function kt(e, o, t, l, s, a) {
  const n = i("IconCaretLeft"), m = i("cdr-button"), _ = i("cdr-text"), v = i("IconXLg");
  return d(), S("div", bt, [t.displayBackArrow ? (d(), g(m, {
    key: 0,
    "aria-label": "Go back",
    class: "back-arrow",
    type: "button",
    "data-ui": "go-back-button",
    "icon-only": !0,
    onClick: o[0] || (o[0] = (b) => e.$emit("go-back"))
  }, {
    icon: c(() => [r(n, {
      "inherit-color": ""
    })]),
    _: 1
  })) : p("", !0), r(_, {
    tag: "h2",
    "data-ui": "header-title",
    class: "header-title"
  }, {
    default: c(() => [h(y(t.title), 1)]),
    _: 1
  }), r(m, {
    "icon-only": !0,
    "aria-label": "Close my store",
    "aria-live": "off",
    class: "my-store-header__close",
    type: "button",
    onClick: o[1] || (o[1] = (b) => e.$emit("closed"))
  }, {
    icon: c(() => [r(v, {
      "inherit-color": ""
    })]),
    _: 1
  })]);
}
const Ct = /* @__PURE__ */ k(vt, [["render", kt], ["__scopeId", "data-v-f54cf057"]]);
const It = {
  name: "StoreAvailability",
  components: {
    CdrText: C,
    IconMinusFill: Le
  },
  props: {
    availability: {
      type: Object,
      required: !0
    },
    temporarilyClosed: {
      type: Boolean,
      default: !1
    }
  }
}, wt = {
  class: "store-availability",
  "data-ui": "store-availability"
};
function Nt(e, o, t, l, s, a) {
  const n = i("IconMinusFill"), m = i("cdr-text");
  return d(), S("div", wt, [t.temporarilyClosed || t.availability.temporarilyClosed ? (d(), g(m, {
    key: 0,
    class: "store-availability--closed",
    "data-ui": "store-temporarily-closed"
  }, {
    default: c(() => [r(n), h(" Temporarily Closed ")]),
    _: 1
  })) : t.availability.open && t.availability.closesAt ? (d(), g(m, {
    key: 1,
    "data-ui": "store-open"
  }, {
    default: c(() => [h(y(t.availability.closesAt), 1)]),
    _: 1
  })) : !t.availability.open && t.availability.opensAt ? (d(), g(m, {
    key: 2,
    class: "store-availability--closed",
    "data-ui": "store-closed"
  }, {
    default: c(() => [h(y(t.availability.opensAt), 1)]),
    _: 1
  })) : p("", !0)]);
}
const ue = /* @__PURE__ */ k(It, [["render", Nt], ["__scopeId", "data-v-78cc5fa8"]]);
const xt = {
  name: "StoreServices",
  components: {
    CdrText: C,
    IconCheckSm: te,
    IconXSm: oe
  },
  props: {
    enabledForCurbside: {
      type: Boolean,
      default: !1
    },
    enabledForInStore: {
      type: Boolean,
      default: !1
    }
  }
}, Lt = {
  class: "store-services"
}, Pt = {
  class: "my-store--sr-only"
}, Dt = {
  class: "my-store--sr-only"
};
function At(e, o, t, l, s, a) {
  const n = i("IconCheckSm"), m = i("IconXSm"), _ = i("cdr-text");
  return d(), S("ul", Lt, [u("li", null, [r(_, {
    class: "flex-a-center"
  }, {
    default: c(() => [t.enabledForCurbside ? (d(), g(n, {
      key: 0,
      class: "check-icon"
    })) : (d(), g(m, {
      key: 1,
      class: "x-icon"
    })), h(" Curbside pickup "), u("span", Pt, y(`${t.enabledForCurbside ? "" : "not "}available`), 1)]),
    _: 1
  })]), u("li", null, [r(_, {
    class: "flex-a-center"
  }, {
    default: c(() => [t.enabledForInStore ? (d(), g(n, {
      key: 0,
      class: "check-icon"
    })) : (d(), g(m, {
      key: 1,
      class: "x-icon"
    })), h(" In-store shopping "), u("span", Dt, y(`${t.enabledForInStore ? "" : "not "}available`), 1)]),
    _: 1
  })])]);
}
const me = /* @__PURE__ */ k(xt, [["render", At], ["__scopeId", "data-v-23484ec6"]]);
N.extend(ne);
N.extend(le);
N.extend(ie);
const he = {
  props: {
    address1: {
      type: String,
      required: !0
    },
    address2: {
      type: String,
      default: ""
    },
    address3: {
      type: String,
      default: ""
    },
    availability: {
      type: Object,
      required: !0
    },
    city: {
      type: String,
      required: !0
    },
    distance: {
      type: Number,
      required: !1
    },
    enabledForCurbside: {
      type: Boolean,
      default: !1
    },
    enabledForInStore: {
      type: Boolean,
      default: !1
    },
    normalHours: {
      type: Array,
      default: () => []
    },
    latitude: {
      type: Number,
      required: !0
    },
    longitude: {
      type: Number,
      required: !0
    },
    phone: {
      type: String,
      required: !1
    },
    state: {
      type: String,
      required: !0
    },
    storeName: {
      type: String,
      required: !0
    },
    storeNumber: {
      type: Number,
      required: !1
    },
    storePageUrl: {
      type: String,
      required: !0
    },
    temporarilyClosed: {
      type: Boolean,
      default: !1
    },
    zip: {
      type: String,
      required: !0
    }
  },
  computed: {
    formattedPhone() {
      return this.phone ? this.phone.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3") : this.phone;
    },
    formattedStoreName() {
      return this.storeName.replace(/\//g, " / ");
    }
  }
}, _e = {
  methods: {
    handleClick(e) {
      const {
        clientWidth: o
      } = window.document.body;
      o >= 992 && (e.preventDefault(), e.stopPropagation());
    }
  }
};
const Ft = {
  name: "StoreInformation",
  components: {
    CdrLink: D,
    CdrText: C,
    CdrButton: A,
    IconBikeShop: Pe,
    IconCaretDown: De,
    IconExternalLink: Ae,
    IconHeartStroke: Fe,
    IconSnow: Me,
    IconTent: He,
    IconRefresh: Be,
    StoreAvailability: ue,
    StoreServices: me
  },
  mixins: [M, _e, he],
  props: {
    analyticsPageName: {
      type: String
    },
    hasBikeShop: {
      type: Boolean,
      default: !1
    },
    hasRentals: {
      type: Boolean,
      default: !1
    },
    hasSkiShop: {
      type: Boolean,
      default: !1
    },
    hasUsedGear: {
      type: Boolean,
      default: !1
    },
    hasTradeIn: {
      type: Boolean,
      default: !1
    },
    isPreferredStore: {
      type: Boolean,
      default: !1
    },
    preferredStoreSelected: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      storeDetailsClosed: !0,
      hasServices: !1
    };
  },
  mounted() {
    (this.hasBikeShop || this.hasRentals || this.hasSkiShop || this.hasUsedGear || this.hasTradeIn || this.normalHours.length) && (this.hasServices = !0);
  },
  methods: {
    handleSetStore() {
      this.$emit("set-my-rei");
    },
    toggleStoreDetails() {
      this.storeDetailsClosed = !this.storeDetailsClosed;
      const e = this.storeDetailsClosed ? "close" : "expand";
      this.sendClickAnalytics({
        linkName: `rei:my store widget_store details ${e}_${this.storeName.toLowerCase()}`,
        pageName: this.analyticsPageName
      });
    },
    trackPhoneClick(e) {
      this.handleClick(e), this.sendClickAnalytics({
        linkName: "rei:my store widget_call store",
        pageName: this.analyticsPageName
      });
    },
    trackStorePageClick() {
      this.sendClickAnalytics({
        linkName: `rei:my store widget_store details_visit store page_${this.storeName.toLowerCase()}`,
        pageName: this.analyticsPageName
      });
    }
  }
}, X = (e) => ($("data-v-efa59fe2"), e = e(), R(), e), Mt = {
  class: "store-information",
  "data-ui": "store-information"
}, Ht = {
  class: "store-information--flex-container"
}, Bt = {
  key: 0,
  class: "store-information__distance",
  "data-ui": "store-distance"
}, Et = /* @__PURE__ */ X(() => /* @__PURE__ */ u("span", {
  class: "my-store--sr-only"
}, "store address", -1)), Tt = /* @__PURE__ */ X(() => /* @__PURE__ */ u("br", null, null, -1)), $t = {
  class: "store-information--flex-container wrapper"
}, Rt = /* @__PURE__ */ X(() => /* @__PURE__ */ u("strong", null, "Store details", -1)), Ot = {
  class: "store-information__my-rei"
}, zt = ["id"], Vt = {
  class: "store-information--flex-container store-information--m-bottom"
}, Ut = {
  class: "store-information--flex-container wrapper"
}, qt = {
  key: 0,
  class: "store-information__available-services"
}, Xt = {
  class: "store-information__available-services"
};
function Yt(e, o, t, l, s, a) {
  const n = i("cdr-text"), m = i("store-availability"), _ = i("IconCaretDown"), v = i("cdr-link"), b = i("IconHeartStroke"), I = i("cdr-button"), w = i("IconBikeShop"), L = i("IconTent"), f = i("IconSnow"), Y = i("IconRefresh"), ge = i("store-services"), Se = i("IconExternalLink");
  return d(), S("div", Mt, [u("div", Ht, [r(n, {
    tag: "h3",
    class: "store-information__name",
    "data-ui": "store-name",
    "aria-label": `${e.formattedStoreName} store`
  }, {
    default: c(() => [h(y(e.formattedStoreName), 1)]),
    _: 1
  }, 8, ["aria-label"]), e.distance ? (d(), S("span", Bt, y(e.distance.toFixed(2)) + " mi", 1)) : p("", !0)]), r(n, {
    "data-ui": "store-address"
  }, {
    default: c(() => [Et, h(" " + y(e.address1) + " " + y(e.address2) + " " + y(e.address3) + " ", 1), Tt, h(" " + y(e.city) + ", " + y(e.state) + " " + y(e.zip), 1)]),
    _: 1
  }), u("div", null, [r(m, {
    availability: e.availability,
    "temporarily-closed": e.temporarilyClosed
  }, null, 8, ["availability", "temporarily-closed"])]), u("div", $t, [B(r(v, {
    tag: "button",
    modifier: "standalone",
    class: "store-information__details",
    "data-ui": "store-details-closed",
    "aria-label": `Open ${e.formattedStoreName} store details`,
    "aria-expanded": `${!s.storeDetailsClosed}`,
    "aria-controls": `store_${e.storeNumber}_details`,
    onClick: a.toggleStoreDetails
  }, {
    default: c(() => [h(" Store details "), r(_, {
      "inherit-color": ""
    })]),
    _: 1
  }, 8, ["aria-label", "aria-expanded", "aria-controls", "onClick"]), [[E, s.storeDetailsClosed]]), B(r(n, {
    tag: "h4",
    class: "store-information--text-200 flex-a-center",
    "data-ui": "store-details-opened"
  }, {
    default: c(() => [Rt]),
    _: 1
  }, 512), [[E, !s.storeDetailsClosed]]), u("div", Ot, [t.isPreferredStore ? p("", !0) : (d(), g(I, {
    key: 0,
    "data-ui": "set-store",
    "aria-label": `Set the ${e.formattedStoreName} store as your preferred REI store`,
    modifier: t.preferredStoreSelected ? "secondary" : "primary",
    class: "flex-a-center",
    size: "small",
    onClick: a.handleSetStore
  }, {
    default: c(() => [r(b, {
      "inherit-color": ""
    }), h(" Set as my REI ")]),
    _: 1
  }, 8, ["aria-label", "modifier", "onClick"]))])]), s.storeDetailsClosed ? p("", !0) : (d(), S("div", {
    key: 0,
    id: `store_${e.storeNumber}_details`,
    "data-ui": "store-details-wrapper",
    "aria-live": "off"
  }, [u("div", Vt, [r(v, {
    href: `tel:${e.phone}`,
    modifier: "standalone",
    class: "store-information__phone",
    "data-ui": "store-phone",
    "aria-label": `Phone number ${e.formattedPhone}`,
    onClick: a.trackPhoneClick
  }, {
    default: c(() => [h(y(e.formattedPhone), 1)]),
    _: 1
  }, 8, ["href", "aria-label", "onClick"])]), u("div", Ut, [s.hasServices ? (d(), S("div", qt, [u("ul", null, [(d(!0), S(P, null, re(e.normalHours, (O) => (d(), S("li", {
    key: O.id
  }, [r(n, {
    class: "store-information--text-200 store-information__hours",
    "data-ui": "store-hours"
  }, {
    default: c(() => [u("span", null, [u("strong", null, y(O.effectiveDay), 1), h(" " + y(O.label), 1)])]),
    _: 2
  }, 1024)]))), 128))]), u("ul", null, [u("li", null, [t.hasBikeShop ? (d(), g(n, {
    key: 0,
    class: "store-information--text-200 store-information--m-top service-wrapper",
    "data-ui": "store-has-bike-shop"
  }, {
    default: c(() => [r(w, {
      size: "small",
      class: "service-icon"
    }), h(" Bike shop ")]),
    _: 1
  })) : p("", !0)]), u("li", null, [t.hasRentals ? (d(), g(n, {
    key: 0,
    class: "store-information--text-200 store-information--m-top service-wrapper",
    "data-ui": "store-has-rentals"
  }, {
    default: c(() => [r(L, {
      size: "small",
      class: "service-icon"
    }), h(" Rentals ")]),
    _: 1
  })) : p("", !0)]), u("li", null, [t.hasSkiShop ? (d(), g(n, {
    key: 0,
    class: "store-information--text-200 store-information--m-top service-wrapper",
    "data-ui": "store-has-ski-shop"
  }, {
    default: c(() => [r(f, {
      size: "small",
      class: "service-icon"
    }), h(" Ski shop ")]),
    _: 1
  })) : p("", !0)]), u("li", null, [t.hasUsedGear ? (d(), g(n, {
    key: 0,
    class: "store-information--text-200 store-information--m-top service-wrapper",
    "data-ui": "store-has-used-gear"
  }, {
    default: c(() => [r(Y, {
      size: "small",
      class: "service-icon"
    }), h(" Used Gear ")]),
    _: 1
  })) : p("", !0)]), u("li", null, [t.hasTradeIn ? (d(), g(n, {
    key: 0,
    class: "store-information--text-200 store-information--m-top service-wrapper",
    "data-ui": "store-has-trade-in"
  }, {
    default: c(() => [r(Y, {
      size: "small",
      class: "service-icon"
    }), h(" Trade-in ")]),
    _: 1
  })) : p("", !0)])])])) : p("", !0), u("div", Xt, [r(ge, {
    "enabled-for-curbside": e.enabledForCurbside,
    "enabled-for-in-store": e.enabledForInStore
  }, null, 8, ["enabled-for-curbside", "enabled-for-in-store"]), r(v, {
    modifier: "standalone",
    "aria-label": `See ${e.formattedStoreName} store page`,
    class: "store-information__page",
    href: `/${e.storePageUrl}`,
    "data-ui": "store-page-url",
    onClick: a.trackStorePageClick
  }, {
    default: c(() => [h(" See store page "), r(Se, {
      "inherit-color": "",
      class: "link-icon"
    })]),
    _: 1
  }, 8, ["aria-label", "href", "onClick"])])]), r(I, {
    size: "small",
    modifier: "secondary",
    "aria-label": `Close ${e.formattedStoreName} store details`,
    class: "store-information__close-details",
    "data-ui": "close-details",
    onClick: a.toggleStoreDetails
  }, {
    default: c(() => [h(" Close store details ")]),
    _: 1
  }, 8, ["aria-label", "onClick"])], 8, zt))]);
}
const fe = /* @__PURE__ */ k(Ft, [["render", Yt], ["__scopeId", "data-v-efa59fe2"]]);
const jt = {
  name: "PreferredStore",
  components: {
    MyRei: q,
    StoreInformation: fe
  },
  props: {
    store: Object
  }
}, Gt = {
  class: "preferred-store",
  "data-ui": "preferred-store"
};
function Wt(e, o, t, l, s, a) {
  const n = i("my-rei"), m = i("store-information");
  return d(), S("div", Gt, [r(n, {
    class: "preferred-store__rei"
  }), (d(), g(m, {
    key: t.store.name,
    address1: t.store.address1,
    address2: t.store.address2,
    address3: t.store.address3,
    availability: t.store.availability,
    city: t.store.city,
    distance: t.store.distance,
    "enabled-for-curbside": t.store.enabledForCurbside,
    "enabled-for-in-store": t.store.enabledForInStore,
    "has-bike-shop": t.store.hasBikeShop,
    "has-rentals": t.store.hasRentals,
    "has-ski-shop": t.store.hasSkiShop,
    "has-trade-in": t.store.hasTradeIn,
    "has-used-gear": t.store.hasUsedGear,
    "normal-hours": t.store.normalHours,
    latitude: t.store.latitude,
    longitude: t.store.longitude,
    phone: t.store.phone,
    state: t.store.state,
    "store-name": t.store.storeDisplayName,
    "store-number": t.store.storeNumber,
    "store-page-url": t.store.storePageUrl,
    "temporarily-closed": t.store.temporarilyClosed,
    zip: t.store.zip,
    "is-preferred-store": !0
  }, null, 8, ["address1", "address2", "address3", "availability", "city", "distance", "enabled-for-curbside", "enabled-for-in-store", "has-bike-shop", "has-rentals", "has-ski-shop", "has-trade-in", "has-used-gear", "normal-hours", "latitude", "longitude", "phone", "state", "store-name", "store-number", "store-page-url", "temporarily-closed", "zip"]))]);
}
const Zt = /* @__PURE__ */ k(jt, [["render", Wt], ["__scopeId", "data-v-3d6d36eb"]]), Z = (e) => {
  let o = "";
  try {
    const {
      pageName: t
    } = JSON.parse(e || "{}") || {};
    o = t;
  } catch {
    console.debug(`Could not parse ${e} into JSON`);
  }
  return o;
};
function Kt() {
  const {
    text: e
  } = document.querySelector('[data-client-store="page-meta-data"]') || {}, {
    text: o
  } = document.getElementById("modelData") || {};
  return Z(e) || Z(o) || "rei:home";
}
function U(e) {
  window && window.metrics && window.metrics.link(e);
}
const Jt = {
  class: "out-of-area",
  "data-ui": "out-of-area"
}, Qt = {
  class: "out-of-area__service"
}, eo = {
  class: "out-of-area__service"
}, to = {
  __name: "OutOfArea",
  props: {
    analyticsPageName: {
      type: String,
      default: "rei:my store widget"
    }
  },
  setup(e) {
    const o = e;
    Re(() => {
      U({
        linkName: "rei:my store widget_far from rei",
        pageName: o.analyticsPageName
      });
    });
    function t() {
      U({
        linkName: "rei:my store widget_free shipping learn more",
        pageName: o.analyticsPageName
      });
    }
    function l() {
      U({
        linkName: "rei:my store widget_virtual outfitting learn more",
        pageName: o.analyticsPageName
      });
    }
    return (s, a) => (d(), S("div", Jt, [r(x(C), {
      tag: "h4",
      class: "out-of-area__title out-of-area--center"
    }, {
      default: c(() => [h(" Looks like you’re far from an REI! ")]),
      _: 1
    }), r(x(C), {
      class: "out-of-area__description out-of-area--center"
    }, {
      default: c(() => [h(" Here are some services for our members like you: ")]),
      _: 1
    }), u("div", Qt, [r(x(Ee)), u("div", null, [r(x(C), {
      tag: "h5",
      class: "out-of-area__title"
    }, {
      default: c(() => [h(" Free shipping ")]),
      _: 1
    }), r(x(C), {
      class: ""
    }, {
      default: c(() => [h(" Orders of $60 or more ship free (U.S. Standard). "), r(x(D), {
        "data-ui": "free-shipping",
        href: "/terms/free-shipping",
        onClick: t
      }, {
        default: c(() => [h(" Learn more ")]),
        _: 1
      })]),
      _: 1
    })])]), u("div", eo, [r(x(Te)), u("div", null, [r(x(C), {
      tag: "h5",
      class: "out-of-area__title"
    }, {
      default: c(() => [h(" Virtual outfitting ")]),
      _: 1
    }), r(x(C), {
      class: ""
    }, {
      default: c(() => [h(" Expert advice just for you, by appointment. "), r(x(D), {
        "data-ui": "virtual-outfitting",
        href: "/outfitting",
        onClick: l
      }, {
        default: c(() => [h(" Learn more ")]),
        _: 1
      })]),
      _: 1
    })])])]));
  }
}, oo = /* @__PURE__ */ k(to, [["__scopeId", "data-v-7229b3b9"]]);
const so = {
  name: "StoreResults",
  components: {
    CdrButton: A,
    CdrText: C,
    CdrLink: D,
    IconLocationPinFill: $e,
    LineDivider: F,
    StoreInformation: fe,
    PreferredStore: Zt,
    OutOfArea: oo
  },
  mixins: [M],
  props: {
    analyticsPageName: {
      type: String
    },
    preferredStore: {
      type: Object,
      default: null
    },
    searchTerm: {
      type: String,
      default: "your location"
    },
    stores: {
      type: Array,
      default: () => []
    },
    showEditLocation: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      showMoreStores: !1
    };
  },
  computed: {
    config() {
      const e = this.stores.filter((s) => this.preferredStore ? s.storeNumber !== this.preferredStore.storeNumber : !0), o = e.length, t = o && e[0].distance > 50, l = this.showMoreStores ? o : 1;
      return {
        stores: t ? e.slice(0, l) : e,
        isOutOfArea: t,
        storesLength: o
      };
    }
  },
  methods: {
    handleEditLocation() {
      this.$emit("edit-location"), this.sendClickAnalytics({
        linkName: "rei:my store widget_edit location",
        pageName: this.analyticsPageName
      });
    },
    handleSetMyRei(e) {
      this.$emit("set-my-rei", e), this.sendClickAnalytics({
        linkName: `rei:my store widget_set as my rei_${e.storeDisplayName.toLowerCase()}`,
        pageName: this.analyticsPageName
      });
    },
    trackAllStoresClick() {
      this.sendClickAnalytics({
        linkName: "rei:my store widget_visit directory of all stores",
        pageName: this.analyticsPageName
      });
    },
    trackShowMoreResults() {
      this.showMoreStores = !0, this.sendClickAnalytics({
        linkName: "rei:my store widget_show more stores",
        pageName: this.analyticsPageName
      });
    }
  }
}, ao = {
  class: "store-results",
  "data-ui": "store-results"
}, ro = {
  key: 0,
  class: "store-results__edit store-results--flex",
  "data-ui": "edit-location-wrapper"
}, io = {
  class: "store-results--hide-scroll"
}, no = {
  class: "store-results__list"
};
function lo(e, o, t, l, s, a) {
  const n = i("IconLocationPinFill"), m = i("cdr-link"), _ = i("cdr-text"), v = i("preferred-store"), b = i("line-divider"), I = i("store-information"), w = i("out-of-area"), L = i("cdr-button");
  return d(), S("div", ao, [t.showEditLocation ? (d(), S("div", ro, [r(n, {
    class: "store-results__pin"
  }), r(_, {
    class: "store-results__near"
  }, {
    default: c(() => [h(" Stores near "), r(m, {
      tag: "button",
      modifier: "standalone",
      "data-ui": "edit-location-link",
      onClick: a.handleEditLocation
    }, {
      default: c(() => [h(y(t.searchTerm || "your location"), 1)]),
      _: 1
    }, 8, ["onClick"])]),
    _: 1
  })])) : p("", !0), u("div", io, [t.preferredStore ? (d(), g(v, {
    key: 0,
    store: t.preferredStore
  }, null, 8, ["store"])) : p("", !0), a.config.storesLength ? (d(), S(P, {
    key: 1
  }, [r(_, {
    class: "store-results__sorted-by",
    "data-ui": "sorted-by"
  }, {
    default: c(() => [h(y(t.preferredStore ? "More options by distance" : "Sorted by distance"), 1)]),
    _: 1
  }), r(b), u("div", no, [(d(!0), S(P, null, re(a.config.stores, (f) => (d(), g(I, {
    key: f.name,
    "data-ui": "store-information",
    "analytics-page-name": t.analyticsPageName,
    address1: f.address1,
    address2: f.address2,
    address3: f.address3,
    availability: f.availability,
    city: f.city,
    distance: f.distance,
    "enabled-for-curbside": f.enabledForCurbside,
    "enabled-for-in-store": f.enabledForInStore,
    "has-bike-shop": f.hasBikeShop,
    "has-rentals": f.hasRentals,
    "has-ski-shop": f.hasSkiShop,
    "has-trade-in": f.hasTradeIn,
    "has-used-gear": f.hasUsedGear,
    "normal-hours": f.normalHours,
    latitude: f.latitude,
    longitude: f.longitude,
    phone: f.phone,
    state: f.state,
    "store-name": f.storeDisplayName,
    "store-number": f.storeNumber,
    "store-page-url": f.storePageUrl,
    "temporarily-closed": f.temporarilyClosed,
    zip: f.zip,
    "preferred-store-selected": !!t.preferredStore,
    onSetMyRei: () => a.handleSetMyRei(f)
  }, null, 8, ["analytics-page-name", "address1", "address2", "address3", "availability", "city", "distance", "enabled-for-curbside", "enabled-for-in-store", "has-bike-shop", "has-rentals", "has-ski-shop", "has-trade-in", "has-used-gear", "normal-hours", "latitude", "longitude", "phone", "state", "store-name", "store-number", "store-page-url", "temporarily-closed", "zip", "preferred-store-selected", "onSetMyRei"]))), 128)), a.config.isOutOfArea ? (d(), S(P, {
    key: 0
  }, [a.config.storesLength > 1 && !s.showMoreStores ? (d(), g(m, {
    key: 0,
    tag: "button",
    onClick: a.trackShowMoreResults
  }, {
    default: c(() => [h(" Show " + y(a.config.storesLength - 1) + " more store" + y(a.config.storesLength > 1 && "s"), 1)]),
    _: 1
  }, 8, ["onClick"])) : p("", !0), r(w, {
    "analytics-page-name": t.analyticsPageName
  }, null, 8, ["analytics-page-name"])], 64)) : p("", !0)])], 64)) : p("", !0), a.config.isOutOfArea ? p("", !0) : (d(), g(b, {
    key: 2,
    class: "store-results__line"
  })), r(L, {
    tag: "a",
    class: "store-results__all-stores",
    modifier: "secondary",
    href: "/stores/map",
    size: "small",
    "data-ui": "all-stores-button",
    "full-width": !0,
    onClick: a.trackAllStoresClick
  }, {
    default: c(() => [h(" Visit directory of all stores ")]),
    _: 1
  }, 8, ["onClick"])])]);
}
const co = /* @__PURE__ */ k(so, [["render", lo], ["__scopeId", "data-v-59edf0b3"]]);
const uo = {
  name: "MyStoreFlyout",
  components: {
    CdrText: C,
    CdrLink: D,
    CdrButton: A,
    IconXLg: se,
    LineDivider: F,
    MyRei: q,
    StoreAvailability: ue,
    StoreServices: me
  },
  mixins: [M, _e, he],
  props: {
    analyticsPageName: {
      type: String
    }
  },
  methods: {
    handleEditMyRei() {
      this.$emit("edit-my-rei", {
        latitude: this.latitude,
        longitude: this.longitude,
        editRei: !0
      }), this.sendClickAnalytics({
        linkName: "rei:my store widget_edit my rei",
        pageName: this.analyticsPageName
      });
    },
    trackAddressClick() {
      this.sendClickAnalytics({
        linkName: "rei:my store widget_store address",
        pageName: this.analyticsPageName
      });
    },
    trackAllStoresClick() {
      this.sendClickAnalytics({
        linkName: "rei:my store widget_visit directory of all stores",
        pageName: this.analyticsPageName
      });
    },
    trackPhoneClick(e) {
      this.handleClick(e), this.sendClickAnalytics({
        linkName: "rei:my store widget_call store",
        pageName: this.analyticsPageName
      });
    },
    trackStorePageClick() {
      this.sendClickAnalytics({
        linkName: "rei:my store widget_visit store page",
        pageName: this.analyticsPageName
      });
    }
  }
}, ye = (e) => ($("data-v-4a343b9e"), e = e(), R(), e), mo = {
  class: "my-store-flyout",
  "data-ui": "store-flyout"
}, ho = {
  class: "my-store-flyout__indicator"
}, _o = {
  class: "my-store-flyout__heading my-store-flyout--flex-container"
}, fo = {
  class: "my-store-flyout__availability"
}, yo = {
  class: "my-store-flyout--flex-container wrapper"
}, po = /* @__PURE__ */ ye(() => /* @__PURE__ */ u("span", {
  class: "my-store--sr-only"
}, "store address", -1)), go = /* @__PURE__ */ ye(() => /* @__PURE__ */ u("br", null, null, -1)), So = {
  class: "my-store-flyout--flex-container wrapper"
};
function vo(e, o, t, l, s, a) {
  const n = i("my-rei"), m = i("IconXLg"), _ = i("cdr-button"), v = i("cdr-text"), b = i("store-availability"), I = i("cdr-link"), w = i("store-services"), L = i("line-divider");
  return d(), S("div", mo, [u("div", ho, [r(n, {
    "indicator-only": !0
  }), r(_, {
    "icon-only": !0,
    "aria-label": "Close my store",
    class: "my-store-flyout__close",
    type: "button",
    onClick: o[0] || (o[0] = (f) => e.$emit("closed"))
  }, {
    icon: c(() => [r(m, {
      "inherit-color": ""
    })]),
    _: 1
  })]), u("div", _o, [r(v, {
    tag: "h2",
    "data-ui": "store-name",
    "aria-label": `${e.formattedStoreName} store`
  }, {
    default: c(() => [h(y(e.formattedStoreName), 1)]),
    _: 1
  }, 8, ["aria-label"]), e.distance ? (d(), g(v, {
    key: 0,
    tag: "span",
    "data-ui": "store-distance"
  }, {
    default: c(() => [h(y(e.distance.toFixed(2)) + " mi ", 1)]),
    _: 1
  })) : p("", !0)]), u("div", fo, [r(b, {
    availability: e.availability,
    "temporarily-closed": e.temporarilyClosed
  }, null, 8, ["availability", "temporarily-closed"])]), u("div", yo, [u("div", null, [r(I, {
    class: "my-store-flyout__phone",
    href: `tel:${e.phone}`,
    "data-ui": "store-phone",
    "aria-label": `Phone number ${e.formattedPhone}`,
    onClick: a.trackPhoneClick
  }, {
    default: c(() => [h(y(e.formattedPhone), 1)]),
    _: 1
  }, 8, ["href", "aria-label", "onClick"]), r(I, {
    href: `https://www.google.com/maps/search/?api=1&query=${e.latitude},${e.longitude}`,
    class: "my-store-flyout__address",
    "data-ui": "store-address",
    onClick: a.trackAddressClick
  }, {
    default: c(() => [po, h(" " + y(e.address1) + " " + y(e.address2) + " " + y(e.address3) + " ", 1), go, h(" " + y(e.city) + ", " + y(e.state) + " " + y(e.zip), 1)]),
    _: 1
  }, 8, ["href", "onClick"])]), r(w, {
    "enabled-for-curbside": e.enabledForCurbside,
    "enabled-for-in-store": e.enabledForInStore
  }, null, 8, ["enabled-for-curbside", "enabled-for-in-store"])]), u("div", So, [u("div", null, [r(_, {
    tag: "a",
    size: "small",
    class: "my-store-flyout__visit-page",
    href: `/${e.storePageUrl}`,
    "data-ui": "store-page-button",
    onClick: a.trackStorePageClick
  }, {
    default: c(() => [h(" Visit store page ")]),
    _: 1
  }, 8, ["href", "onClick"])]), u("div", null, [r(_, {
    size: "small",
    modifier: "secondary",
    class: "my-store-flyout__edit-btn",
    "data-ui": "change-store-button",
    onClick: a.handleEditMyRei
  }, {
    default: c(() => [h(" Edit my REI ")]),
    _: 1
  }, 8, ["onClick"])])]), r(L, {
    class: "my-store-flyout__divider"
  }), r(_, {
    tag: "a",
    modifier: "secondary",
    href: "/stores/map",
    size: "small",
    "data-ui": "all-stores-button",
    "full-width": !0,
    onClick: a.trackAllStoresClick
  }, {
    default: c(() => [h(" Visit directory of all stores ")]),
    _: 1
  }, 8, ["onClick"])]);
}
const bo = /* @__PURE__ */ k(uo, [["render", vo], ["__scopeId", "data-v-4a343b9e"]]);
function ko(e, o, t, l) {
  let s;
  if (e && o && t && l) {
    const a = Math.PI * t / 180, n = Math.PI * e / 180, m = o - l, _ = Math.PI * m / 180;
    s = Math.sin(a) * Math.sin(n) + Math.cos(a) * Math.cos(n) * Math.cos(_), s = Math.acos(s), s = s * 180 / Math.PI, s = s * 60 * 1.1515, s = s.toFixed(2);
  }
  return s;
}
function pe() {
  const e = Oe.get("EdgeLocation");
  if (!e)
    return null;
  const [o, t] = e.split(",");
  return {
    latitude: parseFloat(o).toFixed(3),
    longitude: parseFloat(t).toFixed(3)
  };
}
async function Co() {
  if ("permissions" in navigator) {
    const e = await navigator.permissions.query({
      name: "geolocation"
    });
    if (e.state === "granted")
      return new Promise((o, t) => {
        navigator.geolocation.getCurrentPosition(({
          coords: l
        }) => {
          o({
            latitude: l.latitude.toFixed(3),
            longitude: l.longitude.toFixed(3)
          });
        }, t);
      });
    if (e.state === "denied")
      return pe();
  }
  return null;
}
function K(e, o) {
  if (!e)
    return null;
  let t = null;
  return o && (t = ko(e.latitude, e.longitude, o.latitude, o.longitude)), {
    ...e,
    distance: t ? Number(t) : null
  };
}
N.extend(ne);
N.extend(le);
N.extend(ie);
const T = (e, o) => {
  let t = e;
  t || (t = "0:00am");
  const l = N(`${t}`, "h:mm a").tz(o || "America/Los_Angeles", !0), s = N(l.format()).tz(N.tz.guess()), n = s.minute() > 0 ? "h:mma" : "ha";
  return {
    hours: s.hour() + s.minute() / 100,
    format: l.format(n),
    isValidHour: s.isValid()
  };
}, J = (e, o, t) => e < o ? t >= e && t < o : t >= e || t <= o, Q = (e, o) => o ? o.find((t) => t.effectiveDay === e) : {}, ee = (e = 0) => {
  switch (N().add(e, "day").day()) {
    case 0:
      return "Sun";
    case 6:
      return "Sat";
    default:
      return "Mon-Fri";
  }
}, Io = (e) => {
  const o = {
    open: !1,
    closesAt: null,
    opensAt: null
  };
  if (!e.length)
    return o;
  const t = (/* @__PURE__ */ new Date()).getHours() + (/* @__PURE__ */ new Date()).getMinutes() / 100;
  if (e.find((l) => l.effectiveDate)) {
    const {
      closeHour: l,
      openHour: s
    } = e.find((a) => a.effectiveDate);
    o.open = J(s.hours, l.hours, t), o.closesAt = l.isValidHour ? `Open until ${l.format} today` : null, o.opensAt = s.isValidHour ? `Closed. Opens ${s.format}` : null, o.temporarilyClosed = s.hours === l.hours;
  } else {
    let l = null;
    const s = ee(), {
      closeHour: a,
      openHour: n
    } = Q(s, e);
    if (l = n, o.open = J(l.hours, a.hours, t), !o.open && t >= a.hours) {
      const m = ee(1);
      l = Q(m, e).openHour;
    }
    o.closesAt = a.isValidHour ? `Open until ${a.format} today` : null, o.opensAt = l.isValidHour ? `Closed. Opens ${l.format}` : null, o.temporarilyClosed = l.hours === a.hours;
  }
  return o;
}, wo = (e) => {
  const {
    retailStoreHoursEvents: o
  } = e;
  if (!Array.isArray(o))
    return {};
  const {
    retailStoreHours: t = []
  } = o.find((s) => s.hoursType === "NormalHours") || {};
  return t.map((s) => {
    const a = T(s.closeAt, e.timeZoneId), n = T(s.openAt, e.timeZoneId), m = a.isValidHour && n.isValidHour, _ = s.effectiveDay.replace(/\s+/g, ""), v = n.hours === a.hours ? "Closed" : `${n.format}-${a.format}`;
    return {
      ...s,
      closeHour: a,
      openHour: n,
      effectiveDay: _,
      label: m ? v : ""
    };
  }).sort((s, a) => s.effectiveDay < a.effectiveDay ? -1 : s.effectiveDay > a.effectiveDay ? 1 : 0);
}, No = (e) => {
  const {
    retailStoreHoursEvents: o
  } = e;
  if (!Array.isArray(o))
    return {};
  const t = N(/* @__PURE__ */ new Date()).format("YYYY-MM-DD"), l = o.filter((n) => n.hoursType === "SpecialHours");
  let {
    retailStoreHours: s = []
  } = l.find((n) => n.retailStoreHours.find((m) => N(m.effectiveDate).format("YYYY-MM-DD") === t)) || {};
  return s.length ? (s.length > 1 && (s = [s.find((n) => N(n.effectiveDate).format("YYYY-MM-DD") === t)]), s.map((n) => {
    const m = T(n.closeAt, e.timeZoneId), _ = T(n.openAt, e.timeZoneId), v = m.isValidHour && _.isValidHour, b = n.effectiveDay.replace(/\s+/g, ""), I = _.hours === m.hours ? "Closed" : `${_.format}-${m.format}`;
    return {
      ...n,
      closeHour: m,
      openHour: _,
      effectiveDay: b,
      label: v ? I : ""
    };
  }).sort((n, m) => n.effectiveDay < m.effectiveDay ? -1 : n.effectiveDay > m.effectiveDay ? 1 : 0)) : [];
}, xo = (e) => {
  if (!e)
    return {};
  const o = wo(e), t = No(e), l = t.length ? t : o;
  return {
    ...e,
    hours: l,
    availability: Io(l)
  };
};
const Lo = {
  name: "MyStore",
  components: {
    LoadingStores: et,
    MyLocationInput: St,
    MyStoreFlyout: bo,
    MyStoreHeader: Ct,
    StoreResults: co,
    LoadingFlyout: _t
  },
  mixins: [M],
  props: {
    open: {
      type: Boolean,
      default: !1
    },
    customClasses: {
      type: Array,
      default: () => []
    },
    fetchSuggestedStore: {
      type: Boolean,
      default: !1
    },
    trapTabInsideWidget: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      preferredStore: null,
      suggestedStores: [],
      userCoords: null,
      myStoreState: "idle",
      availableStores: [],
      searchTerm: "",
      states: {
        idle: "idle",
        loading: "loading",
        editPreferredStore: "editPreferredStore",
        loadingFlyout: "loadingFlyout",
        editingLocation: "editingLocation",
        storesLoaded: "storesLoaded",
        myStoreFlyout: "myStoreFlyout"
      },
      errorText: "",
      errorMessages: {
        noStoresFound: "There are no REI stores near that location",
        networkError: "Store search isn't working right now—try again later"
      },
      userListener: null
    };
  },
  computed: {
    analyticsPageName() {
      return `rei:my store widget_${this.analyticsStoreName}`;
    },
    analyticsStoreName() {
      return this.preferredStore ? this.preferredStore.storeDisplayName.toLowerCase() : "no store set";
    },
    /*
      Display back arrow only if user is editing location and already have a preferred store
    */
    displayBackArrow() {
      return this.myStoreState === this.states.editingLocation && !!this.preferredStore;
    },
    storeBarClasses() {
      return [{
        "my-store-inner-bar": !0
      }, ...this.customClasses];
    },
    loadingText() {
      return this.myStoreState === this.states.editPreferredStore ? "Loading..." : "Searching...";
    },
    /*
      Display loading component when fetching results
    */
    showLoading() {
      const {
        loading: e,
        editPreferredStore: o
      } = this.states;
      return [o, e].includes(this.myStoreState);
    },
    /*
      Display loading flyout component when fetching results
    */
    showLoadingFlyout() {
      const {
        loadingFlyout: e
      } = this.states;
      return this.myStoreState === e;
    },
    /*
      Display location input when sidebar is opened for the first of time or if the user
      is editing a location search
    */
    showLocationInput() {
      const {
        idle: e,
        editingLocation: o
      } = this.states;
      return [e, o].includes(this.myStoreState);
    },
    /*
      Display my Store Flyout component with store information
    */
    showMyStoreFlyout() {
      const {
        myStoreFlyout: e
      } = this.states;
      return this.myStoreState === e;
    },
    /*
      Display header
    */
    showHeader() {
      const {
        myStoreFlyout: e,
        loadingFlyout: o
      } = this.states;
      return ![e, o].includes(this.myStoreState);
    },
    /*
      Display results only after api finished loading or if the user is editing a location search
    */
    showResults() {
      const {
        storesLoaded: e,
        editingLocation: o
      } = this.states;
      return this.myStoreState === e || this.myStoreState === o;
    },
    /*
      Changes title for sidebar
    */
    title() {
      switch (this.myStoreState) {
        case this.states.storesLoaded:
          return "Select my store";
        case this.states.editingLocation:
          return "Your store selection";
        default:
          return "Find my store";
      }
    }
  },
  watch: {
    open(e) {
      if (e) {
        this.sendOpenedWidgetAnalytics();
        const o = document.querySelector(".my-store-nav-button");
        o && o.focus();
      } else
        this.fetchSuggestedStore && this.suggestedStores.length && !this.preferredStore ? (this.myStoreState = this.states.storesLoaded, this.availableStores = [...this.suggestedStores]) : (this.myStoreState = this.preferredStore ? this.states.myStoreFlyout : this.states.idle, this.availableStores = []), this.searchTerm = "", this.errorText = "", this.sendClickAnalytics({
          linkName: "rei:my store widget_x out",
          pageName: this.analyticsPageName
        });
    },
    myStoreState() {
      this.open && this.trapTabInsideWidget && this.$nextTick(() => {
        const e = j(this.$refs.mystore);
        e.length && e[0].focus();
      });
    }
  },
  async mounted() {
    this.myStoreState = this.states.loading, document.addEventListener("keydown", this.handleKeyDown);
    try {
      this.userListener = await ve(this.handleUserUpdates);
    } catch (e) {
      console.error(e);
    }
    try {
      const e = await be(), o = await Co();
      this.setUserLocation(o), e && e.preferredStore && e.preferredStore.id !== "0" ? z(e.preferredStore.id).then(() => {
        V().then((t) => {
          this.setStore(t);
        });
      }) : this.fetchSuggestedStore ? this.fetchSuggestedStoreDetails(o) : this.myStoreState = this.states.idle;
    } catch {
      this.myStoreState = this.states.idle, this.errorText = this.errorMessages.networkError;
    }
  },
  beforeUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown), this.userListener && this.userListener.unsubscribe();
  },
  methods: {
    /*
      Method to fetch Stores based on user search
      It is fired when @search-stores event is dispatched from location input
      The searchConfig param can contain:
      - searchTerm if the user entered something on the input field
      - latitude, longitude if the user clicked on my-location link and allowed location
      - updateUserLocation: If user clicks on browser location pop up and allows location, set user location to those coords
    */
    fetchStores(e) {
      const o = this.myStoreState;
      this.errorText = "", this.myStoreState = e.editRei ? this.states.editPreferredStore : this.states.loading, this.searchTerm = e.searchTerm, e.updateUserLocation && (this.setUserLocation(e), this.preferredStore = K(this.preferredStore, this.userCoords)), this.request(e).then((t) => {
        if (this.availableStores = this.getClosestsStores(Object.values(t)), this.availableStores.length === 0)
          this.myStoreState = o, this.errorText = this.errorMessages.noStoresFound;
        else if (this.myStoreState = e.editRei ? this.states.editingLocation : this.states.storesLoaded, !this.preferredStore && this.fetchSuggestedStore && !this.suggestedStores.length) {
          this.suggestedStores = [...this.availableStores];
          const l = !0;
          z(this.suggestedStores[0].storeNumber, l).then(() => {
            V().then((s) => {
              this.$emit("suggested-store", s);
            });
          });
        }
      }).catch(() => {
        this.myStoreState = o, this.errorText = this.errorMessages.networkError;
      });
    },
    /*
      Get suggested store based on user location.
      If no location, fetch user location again using akamai cookie
    */
    fetchSuggestedStoreDetails(e) {
      const o = e || pe();
      o ? this.fetchStores(o) : this.myStoreState = this.states.idle;
    },
    /*
      Sort stores by distance and return only the first five available
    */
    getClosestsStores(e) {
      return Array.isArray(e) ? e.map((t) => ({
        ...t,
        ...xo(t)
      })).sort((t, l) => t.distance - l.distance) : [];
    },
    handleClosed() {
      this.$emit("closed");
    },
    /*
      This function updates preferred store when there is a change on user object handled by the rei/session library
    */
    handleUserUpdates(e) {
      const {
        preferredStore: o
      } = e;
      !o || !o.id || o.id === "0" ? (this.preferredStore = null, this.$emit("select-store", null), this.$emit("set-store", null), this.myStoreState = this.states.idle) : V().then((t) => this.setStore(t));
    },
    handleKeyDown({
      key: e
    }) {
      if (this.open)
        switch (e) {
          case "Escape":
          case "Esc":
            this.$emit("on-escape");
            break;
        }
    },
    handleTab(e, o) {
      if (!this.trapTabInsideWidget)
        return;
      const t = j(this.$refs.mystore), l = t.length - 1;
      if (t.length <= 1) {
        e.preventDefault();
        return;
      }
      o === "next" && e.target === t[l] && (e.preventDefault(), t[0].focus()), o === "back" && e.target === t[0] && (e.preventDefault(), t[l].focus());
    },
    /*
      Make request based on user search preference
      Only opened stores and within a 2600miles range, are fetched
    */
    request({
      latitude: e,
      longitude: o,
      searchTerm: t
    }) {
      if (!e && !o && !t)
        return Promise.resolve(null);
      const s = `/stores/async?${new URLSearchParams({
        dist: 2600,
        visible: !0,
        retail: !0,
        limit: 5,
        open: !0,
        ...t ? {
          search: t
        } : {
          lat: e,
          long: o
        }
      }).toString()}`;
      return fetch(s).then((a) => a.status !== 200 ? Promise.reject(a) : a.json().then((n) => n));
    },
    sendOpenedWidgetAnalytics() {
      const e = {
        linkName: `rei:my store widget_open_no location_${this.analyticsStoreName}`,
        pageName: Kt()
      };
      this.userCoords && (e.linkName = `rei:my store widget_open_location set_${this.analyticsStoreName}`), this.sendClickAnalytics(e);
    },
    setUserLocation(e) {
      const {
        latitude: o,
        longitude: t
      } = e || {};
      !o && !t || (this.userCoords = {
        latitude: o,
        longitude: t
      });
    },
    setStore(e) {
      e && (this.preferredStore = K(e, this.userCoords), this.myStoreState = this.states.myStoreFlyout, this.$emit("set-store", this.preferredStore));
    },
    setAsMyRei(e) {
      const o = this.myStoreState;
      this.myStoreState = this.states.loadingFlyout, z(e.storeNumber).then(() => {
        this.$emit("select-store", e);
      }, () => {
        this.myStoreState = o, this.errorText = this.errorMessages.networkError;
      });
    }
  }
}, Po = ["tabindex"];
function Do(e, o, t, l, s, a) {
  const n = i("my-store-header"), m = i("my-location-input"), _ = i("loading-stores"), v = i("loading-flyout"), b = i("store-results"), I = i("my-store-flyout");
  return d(), S(P, null, [t.open ? (d(), S("div", {
    key: 0,
    id: "my-store-bar",
    ref: "mystore",
    "data-ui": "my-store-bar",
    class: H(a.storeBarClasses),
    "aria-live": "polite",
    onKeydown: [o[2] || (o[2] = G(W((w) => a.handleTab(w, "next"), ["exact"]), ["tab"])), o[3] || (o[3] = G(W((w) => a.handleTab(w, "back"), ["shift"]), ["tab"]))]
  }, [a.showHeader ? (d(), g(n, {
    key: 0,
    title: a.title,
    "display-back-arrow": a.displayBackArrow,
    onGoBack: o[0] || (o[0] = (w) => s.myStoreState = s.states.myStoreFlyout),
    onClosed: a.handleClosed
  }, null, 8, ["title", "display-back-arrow", "onClosed"])) : p("", !0), a.showLocationInput ? (d(), g(m, {
    key: 1,
    "initial-search-value": s.searchTerm,
    "initial-error-text": s.errorText,
    "display-all-stores-btn": s.myStoreState !== s.states.editingLocation,
    "analytics-page-name": a.analyticsPageName,
    "user-coords": s.userCoords,
    onSearchStores: a.fetchStores
  }, null, 8, ["initial-search-value", "initial-error-text", "display-all-stores-btn", "analytics-page-name", "user-coords", "onSearchStores"])) : p("", !0), a.showLoading ? (d(), g(_, {
    key: 2,
    "loading-text": a.loadingText
  }, null, 8, ["loading-text"])) : p("", !0), a.showLoadingFlyout ? (d(), g(v, {
    key: 3
  })) : p("", !0), a.showResults ? (d(), g(b, {
    key: 4,
    "analytics-page-name": a.analyticsPageName,
    "preferred-store": s.preferredStore,
    stores: s.availableStores,
    "search-term": s.searchTerm,
    "show-edit-location": s.myStoreState !== s.states.editingLocation,
    onEditLocation: o[1] || (o[1] = (w) => s.myStoreState = s.states.editingLocation),
    onSetMyRei: a.setAsMyRei
  }, null, 8, ["analytics-page-name", "preferred-store", "stores", "search-term", "show-edit-location", "onSetMyRei"])) : p("", !0), a.showMyStoreFlyout ? (d(), g(I, {
    key: 5,
    "analytics-page-name": a.analyticsPageName,
    address1: s.preferredStore.address1,
    address2: s.preferredStore.address2,
    address3: s.preferredStore.address3,
    availability: s.preferredStore.availability,
    city: s.preferredStore.city,
    distance: s.preferredStore.distance,
    "enabled-for-curbside": s.preferredStore.enabledForCurbside,
    "enabled-for-in-store": s.preferredStore.enabledForInStore,
    "normal-hours": s.preferredStore.normalHours,
    latitude: s.preferredStore.latitude,
    longitude: s.preferredStore.longitude,
    phone: s.preferredStore.phone,
    state: s.preferredStore.state,
    "store-name": s.preferredStore.storeDisplayName,
    "store-page-url": s.preferredStore.storePageUrl,
    "temporarily-closed": s.preferredStore.temporarilyClosed,
    zip: s.preferredStore.zip,
    onEditMyRei: a.fetchStores,
    onClosed: a.handleClosed
  }, null, 8, ["analytics-page-name", "address1", "address2", "address3", "availability", "city", "distance", "enabled-for-curbside", "enabled-for-in-store", "normal-hours", "latitude", "longitude", "phone", "state", "store-name", "store-page-url", "temporarily-closed", "zip", "onEditMyRei", "onClosed"])) : p("", !0)], 34)) : p("", !0), u("div", {
    tabindex: t.open ? "0" : "-1"
  }, null, 8, Po)], 64);
}
const Uo = /* @__PURE__ */ k(Lo, [["render", Do]]);
export {
  Uo as MyStore,
  xo as getStoreHoursAndAvailability
};
